var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('header',[_c('b-navbar',{staticClass:"border-bottom mb-3",attrs:{"type":"dark"}},[_c('b-container',[_c('img',{attrs:{"src":require("../images/logo.svg"),"height":"60","alt":"logo"}})])],1)],1),_c('b-container',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }